import { FORM_EXPORT_CONFIGS } from "../../routes";
import { globs } from "../../services/globs";
import template from "./export-configuration-selector.html";
import "./export-configuration-selector.less";

// export-configuration-selector
export class Controller {
	constructor($logger, securityService, api, appState, loadingService) {
		this.$logger = $logger;
		this.securityService = securityService;
		this.api = api;
		this.appState = appState;
		this.loadingService = loadingService;
	}

	$onInit() {
		if(!this.configurations?.length) {
			this.loadConfigurations();
		}
	}

	loadConfigurations = async() => {
		const configCall = this.api.get(FORM_EXPORT_CONFIGS(this.appState.forms.selected.Id));

		const configs = await this.loadingService.watch(configCall);

		const allowedConfigs = configs.filter(c => this.securityService.isActionAllowed(globs.exports(c.Code).read));

		const toDisplay = (label) => label[0].toUpperCase() + label.slice(1);

		this.configurations = allowedConfigs.map(c => ({ 
			...c,
			display: toDisplay(c.Name ?? c.Code)
		}));

		this.selectedConfiguration = this.configurations[0];

		this.onSelectionChanged(this.selectedConfiguration);
	};
}
export default angular
	.module("vesl.components.export-configuration-selector", [])
	.component("exportConfigurationSelector", {
		template,
		controller: Controller,
		bindings: {
			onSelectionChanged: "<",
			configurations: "="
		}
	}).name;
